export const SCOOTER_HISTORY_LOADING = "scooter-history/loading";
export const SCOOTER_HISTORY_ERROR = "scooter-history/error";
export const SCOOTER_HISTORY_FILTERS = "scooter-history/filters";
export const SCOOTER_HISTORY_LIST = "scooter-history/list";



// WEBPACK FOOTER //
// ./src/actions/scooter/history/constants.js